import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';

import { Tab } from '../../../BulkContext';
import Field from '../Field';

import TeamSection from './teamSection/TeamSection';
import TaskDateField from './TaskDateField';
import TaskDescription from './TaskDescription';
import TaskFields from './TaskFields';

import classes from '../body.module.css';

export interface Props {
  tab: Tab;
}

const TaskBody = ({ tab }: Props) => (
  <div className={classes.body}>
    <div className={classes.bodyHeader}>
      <div className={classes.bodyHeaderTitle}>
        {tab.subText}: {tab.label}
      </div>
    </div>
    <div className={classes.bodyContent}>
      <div className={classes.bodyContentSection}>
        <TeamSection taskIndex={tab.taskIndex} />
      </div>
      <div className={classes.bodyContentTwoColumn}>
        <Field
          icon="event"
          input={
            <TaskDateField
              label="Due Date"
              name="dueDate"
              disabled={doesNotHaveRolePermissions(ROLE_SETS.INSPECTOR)}
              taskIndex={tab.taskIndex}
            />
          }
        />
        <Field
          input={
            <TaskDateField
              label="Start Date"
              name="startTime"
              disabled={doesNotHaveRolePermissions(ROLE_SETS.MANAGER)}
              taskIndex={tab.taskIndex}
            />
          }
        />
      </div>
      <Field
        icon="subject"
        input={<TaskDescription taskIndex={tab.taskIndex} />}
      />
      <TaskFields taskIndex={tab.taskIndex} />
    </div>
  </div>
);

export default TaskBody;
